import React from 'react';

const RankChartPrintHeader = ({ department = {}, modeLabel, pageNumber, season = {}, totalPages }) => {
  return (
    <header className="rank-chart-print-header">
      <div>
        <div className="rank-chart-print-department">{department.DepartmentName || 'Department'}</div>
        {department.OrganizationName && <div className="rank-chart-print-organization">{department.OrganizationName}</div>}
      </div>
      <div className="rank-chart-print-title">
        <strong>Rank Chart</strong>
        <span>{season.SeasonName || 'Season'}</span>
        <span>{modeLabel}</span>
      </div>
      <div className="rank-chart-print-page-number">
        Page {pageNumber} of {totalPages}
      </div>
    </header>
  );
};

export default RankChartPrintHeader;
